/**
 * @module FE-CU27_カメラ設定画面
 */
import Header from '../../components/header/Header.vue';
import BreadCrumbList from '../../components/breadCrumb/List.vue';
import PcPageTitle from '../../components/pcPageTitle/PcPageTitle.vue';
import ListPanel from '../../components/listPanel/ListPanel.vue';
import MobileFooter from '../../components/footer/MobileFooter.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import CONSTANTS from '../../constants';

const PAGE_ID = 'FE-CU27';

export default {
  name: 'CameraSetting',
  components: {
    Header,
    ListPanel,
    MobileFooter,
    BreadCrumbList,
    PcPageTitle,
    PCFooter,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t('$vuetify.FECU27カメラ設定画面.カメラ設定'), //"カメラ設定",
      hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU27カメラ設定画面.C0001'),
      //"カメラの設定項目を選択し、各画面から設定を行うことができます。",
      id: '',
      text: '',
      src: '',
      panelTitle: {
        place: '',
        type: '',
        typeIsBefore: false,
      },
      cameraList: [],
      buttonList: [
        {
          id: 1,
          title: '$vuetify.FECU27カメラ設定画面.ニックネーム設定', // "ニックネーム設定",
          text: '$vuetify.FECU27カメラ設定画面.カメラのニックネームの変更', //"カメラのニックネームの変更",
          image: require('../../assets/images/icon/nicknameSettings.svg'),
          url: '/setCameraNickname',
        },
        {
          id: 2,
          title: '$vuetify.FECU27カメラ設定画面.通知配信設定', //"通知配信設定",
          text: '$vuetify.FECU27カメラ設定画面.通知送信のONOFF', //"通知送信のON／OFF",
          image: require('../../assets/images/icon/notificationDeliverySettings.svg'),
          url: '/cameraNotificationDeliverySettings',
        },
        {
          id: 3, //#27416 [機能修正管理表No.62] 「各種設定」ボタンの追加
          title: '$vuetify.FECU31各種設定画面.各種設定',
          text: '$vuetify.FECU31各種設定画面.アカウント管理_ログイン方法設定',
          image: require('../../assets/images/header_right/settings.svg'),
          url: '/variousSettings',
          //display: true,
        },
        {
          id: 4, //dummy
        },
      ],
      isLoaded: false,
      CONSTANTS: CONSTANTS,
      width: 0,
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU27カメラ設定画面.カメラ設定'), //"カメラ設定",
        hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU27カメラ設定画面.C0001'),
        //"カメラの設定項目を選択し、各画面から設定を行うことができます。",
        panelTitle: {
          place: '',
          type: vm.$vuetify.lang.t('$vuetify.FECU27カメラ設定画面.カメラ詳細表示領域.カメラ詳細'),
          typeIsBefore: false,
        },
      };
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * ボタン押下時(遷移)処理
     * @param {*} url URLパラメータ
     */
    push(url) {
      this.$router.push({
        path: url,
        //query: { hoge_token: data }
      });
    },
    /**
     * カメラ設定データ取得API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストパラメータ
     * @param {*} method メソッドパラメータ
     * @returns apiData レスポンス
     */
    APP_CU2701: async function (param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     cameraInfo: {
            //       usagePlan: 0,
            //       customerNumber: "51-1234567",
            //       securityDestinationName: "警備先1",
            //       districtSplitNumber: "0001",
            //       districtSplitName: "地区名1",
            //       displayDistrictNickname: "自宅",
            //       cameraNickName: "リビングカメラ",
            //       deviceID: "1111",
            //     },
            //     screenDisplayInfo: {
            //       nicknameSetting: true,
            //       notificationDeliverySetting: true,
            //     },
            //   },
            // };

            const targetItem = apiData.contentsInfo.cameraInfo;

            // 取得したデータをマッピングする
            const labels = {
              usagePlan: '$vuetify.FECU27カメラ設定画面.カメラ詳細表示領域.利用プラン', //"利用プラン",
              customerNumber: '$vuetify.FECU27カメラ設定画面.カメラ詳細表示領域.お客様番号', //"お客様番号",
              securityDestinationName: '$vuetify.FECU27カメラ設定画面.カメラ詳細表示領域.警備先名', // "警備先名",
              districtSplitNumber: '$vuetify.FECU27カメラ設定画面.カメラ詳細表示領域.地区番号', // "地区番号",
              displayDistrictNickname:
                '$vuetify.FECU27カメラ設定画面.カメラ詳細表示領域.ニックネーム地区表示', // "ニックネーム(対象地区)",
              districtSplitName: '$vuetify.FECU27カメラ設定画面.カメラ詳細表示領域.地区名', // "地区名",
            };
            const targetKeys = [
              'usagePlan',
              'customerNumber',
              'securityDestinationName',
              'districtSplitNumber',
              'districtSplitName',
              'displayDistrictNickname',
            ];
            const planTitles = {
              [CONSTANTS.CAMERA_USAGE_PLAN.ONLINE_MONITORING_PLAN]:
                '$vuetify.コード.利用プランID.オンライン監視プラン',
              [CONSTANTS.CAMERA_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN]:
                '$vuetify.コード.利用プランID.カメラ依頼かけつけプラン',
              [CONSTANTS.CAMERA_USAGE_PLAN.SELF_MONITORING_PLAN]:
                '$vuetify.コード.利用プランID.カメラセルフ監視プラン',
            };

            Object.keys(targetItem).map((key, index) => {
              if (targetKeys.includes(key)) {
                let text = targetItem[key];
                if (key === 'usagePlan') {
                  text = planTitles[targetItem[key]];
                }
                if (key === 'districtSplitNumber') {
                  if (targetItem[key] === '') {
                    return;
                  }
                  if (targetItem[key] === '    ') {
                    text = '$vuetify.FECU27カメラ設定画面.メイン地区';
                  }
                }

                this.cameraList = [
                  ...this.cameraList,
                  {
                    id: index,
                    title: labels[key],
                    text: text,
                    isVuetifyKey: String(text).includes('$'),
                  },
                ];
              }
            });
            this.panelTitle = {
              place: `- ${apiData.contentsInfo.cameraInfo.cameraNickName} `,
              type: '$vuetify.FECU27カメラ設定画面.カメラ詳細表示領域.カメラ詳細',
              typeIsBefore: true,
            };

            // ニックネーム設定ボタンの表示制御
            //very very no good !!! follow original ......
            if (!apiData.contentsInfo.screenDisplayInfo.nicknameSetting) {
              if (this.buttonList[0].id === 1) {
                this.buttonList.splice(0, 1);
              }
            }

            // 通知配信設定ボタンの表示制御
            //very very no good !!! follow original ......
            if (!apiData.contentsInfo.screenDisplayInfo.notificationDeliverySetting) {
              if (this.buttonList[0].id === 2) {
                this.buttonList.splice(0, 1);
              } else if (this.buttonList[1].id === 2) {
                this.buttonList.splice(1, 1);
              }
            }
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData;
    },
    changeItemLabelWidth(width) {
      this.width = width;
    },
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }

    //何故か、以下通信でローディングマークを出してるので、ここで画面表示
    this.isShowPage = true;

    let param = '/api/cameraSetting/init';
    // let param = "post";

    let queries = {
      token: sessionStorage.getItem('token'),
      terminalInfo: localStorage.getItem('terminalInfo')
        ? localStorage.getItem('terminalInfo')
        : '',
      deviceID: this.$store.state.deviceID,
    };

    let method = 'post';

    // APP_CU2701
    await this.APP_CU2701(param, queries, method);
    this.isLoaded = true;
  },
};
